module.exports = __webpack_public_path__ + "img/cube@2x.1eacf4a0.png";